module.exports = __webpack_public_path__ + "static/media/DT11.d6fd08b1.jpg";